<form [formGroup]="paymentForm" (ngSubmit)="submitForm()" class="tab-form" autocomplete="off" novalidate>
  <div class="form-80">
    <h1 class="blue margin">{{ title }}</h1>
    <p class="lead rocal">
      {{ subtitle }}
    </p>

    <div class="flex blue-box" style="margin-top: 5px; margin-bottom: 3px;">
      <div style="display: flex; gap: 40px;">
        <p style="display: flex; font-weight: 600;">
          Total amount
        </p>
        <p class="blue lead" style="font-size: larger;"> KSH{{' ' +willAmount.toLocaleString('en-US')}} </p>
      </div>
      
      <div class="line-2" style="margin-bottom: 20px;"></div>

      <div style="display: flex; align-items: center; gap: 24px;">

        <div class="flex column pay-bar grey-box" style="width: fit-content; padding: 24px;">
          <p class="lead rocal">Amount to pay ( +{{ vatAmount }}% VAT )</p>
          <p class="blue lead" style="font-size: larger; margin-top: 0px;"><strong>KSH{{' ' +returnNetAmount().toLocaleString('en-US')}}</strong></p>
        </div>
      </div>
        
      <div class="line-2" style="margin-top: 25px;"></div>
      <!-- PAYMENT DETAILS -->
      <div *ngIf="!payment.done">
        <!-- REFERREE -->
        <p class="blue lead" style="margin-top: 30px;">
            {{ referreeTitle }}
        </p>
          <div class="row" style="margin-top: 10px;"
            [ngClass]="{'width-50' : !(
              paymentForm.get('referree')?.value === 'Other' ||
              paymentForm.get('referree')?.value === 'Independent Agent' ||
              paymentForm.get('referree')?.value === 'Broker' ||
              paymentForm.get('referree')?.value === 'ICEA LION Financial Advisor' ||
              paymentForm.get('referree')?.value === 'ICEA LION Trust Consultant'
            )}
          ">
            <app-input [formGroup]="paymentForm" controlName="referree"
              label={{referreLabel}} hint={{selectText}}
              inputType="select"
              [ArrayItems]="HearAboutusData"
              [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
  
            <app-input [formGroup]="paymentForm" controlName="other"
              *ngIf="paymentForm.get('referree')?.value === 'Other'"
              label={{referreeOtherLabel}} hint={{referreeOtherHint}}
              [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
              
              <app-input [formGroup]="paymentForm" controlName="referreeName"
                *ngIf="paymentForm.get('referree')?.value === 'Independent Agent' ||
                    paymentForm.get('referree')?.value === 'Broker' ||
                    paymentForm.get('referree')?.value === 'ICEA LION Financial Advisor' ||
                    paymentForm.get('referree')?.value === 'ICEA LION Trust Consultant' "

                [label]="
                    paymentForm.get('referree')?.value === 'Broker' ? 'Name of Broker' :
                    paymentForm.get('referree')?.value === 'ICEA LION Trust Consultant' ? 'Name of Consultant' :
                    paymentForm.get('referree')?.value === 'ICEA LION Financial Advisor' ? 'Name of Financial Advisor'
                    : agentLabel"
                      
                inputType="auto-complete"
                [ArrayItems]="IntermediaryOptions"
                [loadingOptions]="loadingIntermediaries"
                hint={{agentHint}}
                [validationMessages]="validationMessages" [formErrors]="formErrors">
            </app-input>
          </div>
          <div class="line-2" style="margin-top: 25px;"></div>
          <!-- PAYMENT -->
          <p class="blue lead" style="margin-top: 30px;">
            {{ paymentDetailsTitle }}
          </p>
          <div class="row" [ngClass]="{'half': (paymentForm.controls['PaymentMode'].value != PaymentModeOptions[1] && paymentForm.controls['PaymentMode'].value != PaymentModeOptions[3])}">
            <app-input
              [formGroup]="paymentForm"
              controlName="PaymentMode"
              label={{paymentModeLabel}}
              inputType="select"
              [ArrayItems]="PaymentModeOptions"
              [validationMessages]="validationMessages" [formErrors]="formErrors" ></app-input>
            <app-input [formGroup]="paymentForm" controlName="receipt"  *ngIf="paymentForm.controls['PaymentMode'].value === PaymentModeOptions[1]"
              label="M-PESA Receipt" hint={{receiptLabel}} subtext={{receiptHint}} required="false"
              [validationMessages]="validationMessages" [formErrors]="formErrors" ></app-input>
            <app-input [formGroup]="paymentForm" *ngIf="paymentForm.controls['PaymentMode'].value === PaymentModeOptions[3]"
              inputType="view"
              label='Amount' hint="{{ 'KSH ' +returnNetAmount().toLocaleString()}}"></app-input>
          </div>

          <!-- BANK PAYMENT-->
          <div *ngIf="paymentForm.controls['PaymentMode'].value == PaymentModeOptions[2]">
            <div class="row">
              <app-input [formGroup]="paymentForm"
                inputType="view"
                label='Pay'
                hint="{{ 'KSH ' +returnNetAmount().toLocaleString()}}"></app-input>
              <app-input [formGroup]="paymentForm" controlName="bank"
                [selectFunction]="populateBankBranchesList.bind(this)"
                inputType="select"
                [ArrayItems]="BanksOptions"
                [loadingOptions]="loadingBanks"
                label={{bankLabel}} hint={{bankHint}}
                [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
            </div>

            <div class="row">
              <app-input [formGroup]="paymentForm" controlName="bankBranch"
                  label={{bankBranchLabel}} hint={{bankBranchHint}}
                  inputType="select"
                  [ArrayItems]="BranchPlaceHolders"
                  [loadingOptions]="loadingBankBranches"
                  [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
              <app-input [formGroup]="paymentForm" controlName="accName"
                  label={{accNameLabel}} hint={{accNameHint}}
                  [validationMessages]="validationMessages" [formErrors]="formErrors" ></app-input>
            </div>
  
              <div class="row">
                  <app-input [formGroup]="paymentForm" controlName="acc"
                      label={{accLabel}} hint={{accHint}}
                      [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input
                      >
                  <app-input [formGroup]="paymentForm" controlName="slipDoc"
                      [fileFunction]="updateSlipObject.bind(this)"
                      label={{uploadSlipLabel}} inputType="file"
                      [validationMessages]="validationMessages" [formErrors]="formErrors" ></app-input>
              </div>
          </div>

          <!-- PAYMENT MPESA -->
          <div *ngIf="paymentForm.controls['PaymentMode'].value == PaymentModeOptions[0]">
              <div class="row">
                  <app-input [formGroup]="paymentForm" controlName="phone"
                      label={{phoneLabel}} inputType="phone"
                      [validationMessages]="validationMessages" [formErrors]="formErrors" ></app-input>
                  <app-input [formGroup]="paymentForm"
                      inputType="view"
                      label='Amount' hint="{{ 'KSH ' +returnNetAmount().toLocaleString()}}"></app-input>
              </div>
          </div>

          <!-- PAYMENT DIRECT CARD -->
          <app-cards *ngIf="paymentForm.controls['PaymentMode'].value == PaymentModeOptions[3]"
            #cardsComponent
            returnURL="estate-planning/set-up"
            [formGroup]="paymentForm"
            [payer]="testators[0]"
            [amount]="returnNetAmount()"
            (paymentSuccess)="onCardPaymentSuccess()"
          ></app-cards>

          <!-- BANK DETAILS -->
          <div *ngIf="paymentForm.controls['PaymentMode'].value == PaymentModeOptions[2]" class="bankBox-wrap">
              <div class="bankBox">
                  <p class="lead blue" style="margin-bottom: -20px; margin-left: 0px; font-weight: 600;">
                      {{instructionsTitleBank}}
                  </p>
                  <div class="line"></div>
                  <div class="row">
                      <div>{{iceaFundLabel}}</div> <div class="right-divs">{{iceaFundNameVal}}</div>    
                  </div>
                  <div class="row">
                      <div>{{iceaAcc}}</div> <div class="right-divs">{{iceaAccountVal}}</div>
                  </div>
                  <div class="row">
                      <div>{{iceaBank}}</div> <div class="right-divs">{{iceaBankVal}}</div>
                  </div>
                  <div class="row">
                      <div>{{iceaBranch}}</div> <div class="right-divs">{{iceaBranchVal}}</div>
                  </div>
                  <div class="row">
                      <div>{{iceaBankCode}}</div> <div class="right-divs">{{iceaBankCodeVal}}</div>
                  </div>
                  <div class="row">
                      <div>{{iceaBranchCode}}</div> <div class="right-divs">{{iceaBranchCodeVal}}</div>
                  </div>
                  <div class="row">
                      <div>{{iceaClearing}}</div> <div class="right-divs">{{iceaClearingVal}}</div>
                  </div>
              </div>
          </div>

          <!-- M-PESA EXPRESS DETAILS -->
          <div *ngIf="paymentForm.controls['PaymentMode'].value == PaymentModeOptions[0]" class="badge-wrapper">
              <div class="badge">
                  <p class="lead blue" style="font-size: larger; margin-left: 2.8%; font-weight: 600;">
                      {{instructionsTitle}}
                  </p>
                  <ol>
                      <li>{{inst1}}</li>
                      <li>Click on the <strong>"Submit"</strong> Button below.</li>
                      <li>{{inst2}}</li>
                      <li>{{inst2X}}</li>
                      <li>{{inst3}}</li>
                  </ol>

                  <div style="height: 20px;"></div>
              </div>
          </div>

          <!-- M-PESA PAYBILL DETAILS -->
          <div *ngIf="paymentForm.controls['PaymentMode'].value == PaymentModeOptions[1]" class="badge-wrapper">
              <div class="badge">
                  <p class="lead blue" style="font-size: larger; margin-left: 2.8%; font-weight: 600;">
                      {{instructionsTitle2}}
                  </p>
                  <ol>
                      <li>Ensure you have filled in the form above correctly (The <strong>Confirm Payment</strong> Button should turn <strong>blue</strong>)</li>
                      <li>{{inst4}}</li>
                      <li>{{inst5}}<b>{{iceaPaybill}}</b></li>
                      <li>{{inst6}}<b>{{ paymentID }}</b></li>
                      <li>Set the amount as <strong>Ksh {{returnNetAmount()}}</strong></li>
                      <li>{{inst8}}</li>
                      <li>Please do <strong>NOT</strong> close this page <strong>UNTIL</strong> the Payment is confirmed</li>
                      <li>If the payment isn't completed automatically, use the <strong>"Confirm Payment"</strong> Button to Confirm the status</li>
                  </ol>

                  <div style="height: 20px;"></div>
              </div>
          </div>

          <!-- CARD DETAILS -->
          <div *ngIf="paymentForm.controls['PaymentMode'].value == PaymentModeOptions[3]" class="badge-wrapper">
              <div class="badge">
                  <p class="lead blue" style="font-size: larger; margin-left: 2.8%; font-weight: 600;">
                      {{'Card Payment Instructions'}}
                  </p>
                  <ol>
                      <li>Ensure you have filled in the card details form above correctly (The <strong>Submit</strong> Button should turn <strong>blue</strong>)</li>
                      <li>Please do <strong>NOT</strong> close this page <strong>UNTIL</strong> the Payment is confirmed</li>
                  </ol>

                  <div style="height: 20px;"></div>
              </div>
          </div>
      </div>
      <!-- PAYMENT SUMMARY -->
      <div *ngIf="payment.done">
          <div class="badge-wrapper" style="margin-top: 0px;">
              <div class="badge">
                  <p class="lead blue" style="font-size: larger; margin-left: 2.8%; font-weight: 600;">
                      {{ 'Payment Summary' }}
                  </p>
                  <ul>
                      <li>{{'Payment Mode : '}}&nbsp;&nbsp;<b>{{ payment.mode || 'MPESA' }}</b></li>
                      <li *ngIf="payment.mode != 'RTGS' ">{{'Phone Number : '}}&nbsp;&nbsp;<b>{{ payment.phone || '0712333454' }}</b></li>
                      <li>Paid Amount&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;<b>KSH{{payment.Amount ? ' ' +payment.Amount.toLocaleString('en-US') : ' 10, 000 Tests' }}</b></li>
                      
                      <br *ngIf="payment.mode != 'RTGS' ">
                      <li *ngIf="payment.mode != 'RTGS' ">    
                        {{ paymentForm.controls['PaymentMode'].value == PaymentModeOptions[3] ? 'Reference' : 'MPESA Receipt : ' }}
                        <b style="color: #003764;">{{ stkRequestID }}</b>
                      </li>
                  </ul>
                  <div style="height: 20px;"></div>
              </div>
          </div>
      </div>
    </div>
  </div>

  <!-- BOTTOM OF FORM -->
  <app-form-bottom style="width: 100%;"
    [service]="estateControlService"
    [text]="payment.done ? (loading ? 'Saving Details': 'Next') : (loading ? 'Processing Payment': paymentForm.controls['PaymentMode'].value == PaymentModeOptions[1] ? 'Confirm Payment' : 'Submit') "
    [formValid]="payment.done || payment.uploaded ? true : paymentForm.valid ? true : false"
    [showContinue]="'false'"
    [buttonClickHandler]="submitForm.bind(this)">
  </app-form-bottom>
</form>
